let formUserCols = [
    {
        key: 'resellerId',
        display: 'Reseller Id'
    },
    {
        key: 'resellerName',
        display: 'Reseller Name'
    },
    {
        key: 'emailAddress',
        display: 'Email Address'
    },
    {
        key: 'locked',
        display: 'Locked'
    },
    {
        key: 'forcePasswordChange',
        display: 'Force Pwd Change'
    },
    {
        key: 'lastSignedInDateAsLocalTime',
        display: 'Last Signed In'
    },
    {
        key: 'dateCreatedAsLocalTime',
        display: 'Created'
    }
]

export { formUserCols }